import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://installmentzone.com/pharmacy/api";

const CHECK_INTERVAL = 5000; // check every 5 seconds for short trials

const useLicenseCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkLicense = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/"); // Not logged in
        return;
      }

      try {
        const res = await axios.get(`${API_BASE_URL}/check_certificate.php`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // ✅ License active
        if (res.data.status === "success") return;

        // ❌ License expired (backend returned status:error)
        const message = res.data.message || "";
        if (message.toLowerCase().includes("expired") || message.toLowerCase().includes("renew")) {
          toast.error("Your license has expired. Please renew!");
          localStorage.removeItem("token");
          localStorage.removeItem("rememberEmail");
          localStorage.removeItem("rememberPassword");
          navigate("/renew-license");
        }
      } catch (err) {
        // Catch backend errors (expired or invalid token)
        const backendMessage = err.response?.data?.message || "";
        if (
          backendMessage.toLowerCase().includes("expired") ||
          backendMessage.toLowerCase().includes("renew") ||
          backendMessage.toLowerCase().includes("invalid token")
        ) {
          toast.error("Your license has expired or session invalid. Please renew!");
          localStorage.removeItem("token");
          localStorage.removeItem("rememberEmail");
          localStorage.removeItem("rememberPassword");
          navigate("/renew-license");
        } else {
          console.error("License check failed:", err.response?.data || err);
        }
      }
    };

    // Run immediately
    checkLicense();

    // Run every 5 seconds
    const interval = setInterval(checkLicense, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [navigate]);
};

export default useLicenseCheck;